import { useQuery } from '@tanstack/react-query';
import { SiteMode } from '@meshsmith/shared';
import type { SiteStatusDTO } from '@meshsmith/shared';
import { api } from '../lib/api';

/**
 * Polls the admin-managed storefront availability status. Kept lightweight and
 * refetched on focus so staff can flip modes and see it propagate quickly.
 */
export function useSiteStatus() {
  const query = useQuery({
    queryKey: ['site-status'],
    queryFn: () => api.get<SiteStatusDTO>('/content/site-status'),
    staleTime: 20_000,
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
    retry: 1,
  });

  const status = query.data;
  return {
    ...query,
    status,
    isLive: !status || status.mode === SiteMode.LIVE,
    mode: status?.mode ?? SiteMode.LIVE,
  };
}
